var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"not-found"},[_c('header',[_c('h1',[_vm._t("default",[_vm._v("Nothing here :( ")])],2)]),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }